import React from 'react';
import { Card, CardContent } from '../../../components/ui/card';
import { Skeleton } from '../../../components/ui/skeleton';
import { Sparkles, AlertCircle } from 'lucide-react';

function CopilotPanel({ suggestion, loading, error }) {
  return (
    <div className="flex flex-col h-full">
      <h3 className="text-xs font-semibold tracking-wider text-white/40 uppercase mb-3 flex items-center gap-1.5">
        <Sparkles className="w-3.5 h-3.5 text-[#00d4aa]" /> Next Best Line
      </h3>

      {loading && (
        <Card className="bg-[#00d4aa]/5 border border-[#00d4aa]/20">
          <CardContent className="p-4 space-y-2">
            <Skeleton className="h-3 w-full bg-white/10" />
            <Skeleton className="h-3 w-4/5 bg-white/10" />
          </CardContent>
        </Card>
      )}

      {!loading && error && (
        <Card className="bg-white/5 border border-white/10">
          <CardContent className="p-4 flex items-start gap-2">
            <AlertCircle className="w-4 h-4 text-yellow-400 flex-shrink-0 mt-0.5" />
            <p className="text-xs text-white/60">Copilot unavailable — continue manually.</p>
          </CardContent>
        </Card>
      )}

      {!loading && !error && suggestion && (
        <Card className="bg-[#00d4aa]/10 border border-[#00d4aa]/30 rounded-lg">
          <CardContent className="p-4">
            <p className="text-sm text-white/90 leading-relaxed">&ldquo;{suggestion}&rdquo;</p>
          </CardContent>
        </Card>
      )}

      {!loading && !error && !suggestion && (
        <Card className="bg-white/5 border border-white/10 border-dashed">
          <CardContent className="p-4">
            <p className="text-xs text-white/40">
              Type a note or click an objection and the copilot will suggest the next line.
            </p>
          </CardContent>
        </Card>
      )}
    </div>
  );
}

export default CopilotPanel;
